/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Modal } from "@clarkinc/zest-design-system";
import Stars from "~/common/Stars";
import BrandTopProducts from "./BrandTopProducts";
import { BrandDetail } from "~/common/Store/models/Brand";
import ZestVideoModal from "~/common/VideoModal/ZestVideoModal";
import VendorPartsData from "./data/VendorPartsData";

const BrandPageHeader = ({
  pageHeader,
  name,
  brandLogo,
  headline,
  visibleText,
  hiddenText,
  overallRating,
  topProducts,
  video,
  groupAttributes,
  expandedPageAttributes,
  link,
}: BrandDetail) => {
  const [showHiddenText, setShowHiddenText] = useState(false);
  const [showReadMoreText, setShowReadMoreText] = useState(true);

  const handleReadMoreClick = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    e.preventDefault();
    setShowHiddenText(true);
    setShowReadMoreText(false);
  };

  const handleVideoClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();
    Modal.toggle("zestVideoModal");
  };

  const hasText = headline || visibleText || hiddenText;

  const showShopAllLink = VendorPartsData.filter(
    (vendor) => vendor.link === link && !expandedPageAttributes.isExpandedBrand,
  );

  return (
    <div className="grid-layout">
      <div className="grid-container grid-module-large overflow-visible">
        <div
          className={`grid-module grid-children-5 vendor-main overflow-visible ${
            topProducts.length <= 2 ? "vendor-small" : ""
          }`}
        >
          <span className="grid-item grid-parent overflow-visible">
            {video ? (
              <>
                <a href="#" className="grid-image" onClick={handleVideoClick}>
                  <div className="vendor-play-btn" />
                  <img
                    className="lazyLoad"
                    data-testid="category-image"
                    alt={name}
                    src={brandLogo}
                  />
                </a>
                <ZestVideoModal video={video} />
              </>
            ) : (
              <a className="grid-image">
                <img
                  className="lazyLoad"
                  data-testid="category-image"
                  alt={name}
                  src={brandLogo}
                />
              </a>
            )}
            <div className="grid-right">
              <span className="grid-text">
                <h1 className="vendor__header" data-testid="page-header">
                  {pageHeader}
                </h1>
                {!hasText && overallRating > 0 && (
                  <p id="rating_desc">
                    Our Overall User Rating represents the average star rating
                    given in all customer reviews for {name}&apos;s products.
                    Use our Overall Customer Rating to evaluate the brand&apos;s
                    quality based on feedback from your fellow customers!
                  </p>
                )}
                {!!groupAttributes?.parentName && (
                  <span className="vendor__parent-brand">
                    by &nbsp;
                    <a
                      href={groupAttributes.parentUrl}
                      title={groupAttributes.parentName}
                    >
                      {groupAttributes.parentName}
                    </a>
                  </span>
                )}
                <div className="rate-box vendor-rating">
                  <p>Overall Customer Rating:</p>
                  <div className="stars">
                    <Stars rating={overallRating} />
                  </div>
                  <div className="clearfix" />
                  {showShopAllLink.length > 0 ? (
                    <a
                      className="btn btn-info mt-2.5 mb-5"
                      href={showShopAllLink[0]?.shopAllLink}
                    >{`Shop All ${name} Parts`}</a>
                  ) : null}
                </div>
                {hasText && (
                  <div>
                    {headline && (
                      <h2 className="vendor-subtitle">{headline}</h2>
                    )}
                    {visibleText && (
                      <>
                        <p className="vendor-desc" data-testid="vendor-desc">
                          <span
                            dangerouslySetInnerHTML={{ __html: visibleText }}
                          />
                          {hiddenText && showReadMoreText && (
                            <a
                              href="#"
                              data-testid="read-more"
                              onClick={handleReadMoreClick}
                            >
                              {" Read more "}
                              <i
                                className="icon-breadcrumb"
                                aria-hidden="true"
                              />
                            </a>
                          )}
                        </p>
                      </>
                    )}
                    {hiddenText && (
                      <div
                        id="supporting-content"
                        data-testid="supporting-content"
                        className={`collapse out${showHiddenText ? " in" : ""}`}
                      >
                        <p
                          className="vendor-desc"
                          data-testid="vendor-desc"
                          dangerouslySetInnerHTML={{ __html: hiddenText }}
                        />
                      </div>
                    )}
                  </div>
                )}
              </span>
              {topProducts.length <= 2 && (
                <BrandTopProducts topProducts={topProducts} />
              )}
            </div>
          </span>
          {topProducts.length >= 3 && (
            <BrandTopProducts topProducts={topProducts} />
          )}
        </div>
      </div>
    </div>
  );
};
export default BrandPageHeader;
